export default (yearString = 0, monthString = 0) => {

    let years = Number(yearString) || 0;
    let months = Number(monthString) || 0;

    return (years * 12) + months;

};